// eslint-disable-next-line import/no-anonymous-default-export
export default {
  'Language Created Successfully': 'تم إضافة اللغة بنجاح',
  'set Default Language': 'اختيار كلغة رئيسية',
  'Remove Default Language': 'إعادة تعيين كلغة رئيسية',
  'Default Language Status Changed Succefully': 'تم تغيير اللغة الرئيسية بنجاح',
  'Language Order Already Exists': 'الترتيب موجود بالفعل',
};
